if (!customElements.get('hydra-syn-details')) {
  customElements.define('hydra-syn-details', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.hydra-syn-details__head');
        if (!button) return;
        const item = button.closest('.hydra-syn-details__item');
        const panel = item.querySelector('.hydra-syn-details__panel');
        const opening = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(opening));
        panel.setAttribute('aria-hidden', String(!opening));
        panel.inert = !opening;
        if (panel.animationFrame) cancelAnimationFrame(panel.animationFrame);
        panel.style.maxHeight = panel.getBoundingClientRect().height + 'px';
        item.classList.toggle('is-open', opening);
        panel.animationFrame = requestAnimationFrame(() => {
          panel.style.maxHeight = opening ? panel.scrollHeight + 'px' : '0px';
        });
      }, { signal: this.events.signal });
      this.resizeObserver = new ResizeObserver((entries) => {
        entries.forEach(({ target }) => {
          const panel = target.parentElement;
          if (panel.getAttribute('aria-hidden') === 'false') {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        });
      });
      this.querySelectorAll('.hydra-syn-details__body').forEach((body) => this.resizeObserver.observe(body));
    }
    disconnectedCallback() {
      this.events?.abort();
      this.resizeObserver?.disconnect();
      this.querySelectorAll('.hydra-syn-details__panel').forEach((panel) => cancelAnimationFrame(panel.animationFrame));
    }
  });
}
